module.exports = __webpack_public_path__ + "img/background033.741f74e4.jpg";